import { render, staticRenderFns } from "./layout-order.vue?vue&type=template&id=0b8054c4&scoped=true&"
import script from "./layout-order.vue?vue&type=script&lang=js&"
export * from "./layout-order.vue?vue&type=script&lang=js&"
import style0 from "./layout-order.vue?vue&type=style&index=0&id=0b8054c4&lang=less&scoped=true&"
import style1 from "./layout-order.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8054c4",
  null
  
)

export default component.exports